<template>
  <v-form v-model="valid" lazy-validation ref="form">
    <v-row dense>        
      <v-col>
        <v-text-field type="number" v-model="numIncSDComputed"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field type="date" v-model="startDateComputed" :rules="rules.startDate"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field type="number" v-model="numIncEDComputed">
        </v-text-field>
      </v-col>        
      <v-col>
        <v-text-field type="date" v-model="endDateComputed" :rules="rules.endDate"></v-text-field>
      </v-col> 
    </v-row> 
  </v-form>
</template>

<script>
import moment from "moment";

export default {
  name: 'DateFilterComponent',
  props : {
      startDate : {type:String, default: null},
      endDate : {type:String, default: null},
      numIncSD: {type:String, default: "-1"},
      numIncED: {type:String, default: "0"},
  },  
  components: {},
  computed : {
    rules() {
      debugger;
      const valid = moment(this.startDateInternal) <= moment(this.endDateInternal);
      return {
        startDate: [() => valid || "Start Date cannot be greater than End Date"], 
        endDate: [() => valid || "End Date cannot be less than Start Date"]
      };
    },
    startDateComputed: {
      get() 
      {
        if(!this.startDateInternal) this.startDateInternal = this.startDate ?? moment().add(this.numIncSDComputed, 'days').format(this.dateFormat);
        return this.startDateInternal;
      },
      set(val)
      {
        this.startDateInternal = val;
        this.numIncSDInternal = moment(val).diff(moment().startOf('day'), 'days');
      }
    },
    endDateComputed: {
      get() 
      {
        debugger;
        if(!this.endDateInternal) this.endDateInternal = this.endDate ?? moment().add(this.numIncEDComputed, 'days').format(this.dateFormat);
        return this.endDateInternal;
      },
      set(val)
      {
        this.numIncEDInternal = moment(val).diff(moment().startOf('day'), 'days');
        this.endDateInternal = val;
      }
    },    
    numIncSDComputed: {
      get(){
        if(!this.numIncSDInternal && this.numIncSD) this.numIncSDInternal = this.numIncSD;
        return this.numIncSDInternal;
      },
      set(val){
        this.numIncSDInternal = val;
        this.startDateInternal = moment().add(val, 'days').format(this.dateFormat);
      }
    },
    numIncEDComputed: {
      get(){
        if(!this.numIncEDInternal && this.numIncED) this.numIncEDInternal = this.numIncED;
        return this.numIncEDInternal;
      },
      set(val){
        this.endDateInternal = moment().add(val, 'days').format(this.dateFormat);
        this.numIncEDInternal = val;
      }
    },      
  },
  watch: {
    startDateInternal(val){
      this.$emit('update:startDate',val);
    },
    endDateInternal(val){
      this.$emit('update:endDate',val);
    },
    numIncSDInternal(val){
      this.$emit('update:numIncSD',val);
    },
    numIncEDInternal(val){
      this.$emit('update:numIncED',val);
    },
  },
  data: () => ({
      dateFormat: "YYYY-MM-DD",
      valid: false,
      numIncSDInternal: null,
      numIncEDInternal: null,
      startDateInternal: null,
      endDateInternal: null,      
  }),
}
</script>

<style scoped lang="scss">
</style>
